import styled from "styled-components";

export const Wrapper = styled.section`
  overflow: hidden;
  position: relative;
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: ${({ $viewMode }) => ($viewMode === "compact" ? "8px" : "20px")};
  grid-template-areas:
    "vote options"
    "text text";
  width: 100%;
  margin: ${({ $viewMode }) =>
    $viewMode === "compact" ? "0 0 8px" : "0 0 16px"};
  padding: ${({ $viewMode }) =>
    $viewMode === "compact" ? "10px 16px" : "24px"};
  background: var(--white);
  border-radius: ${({ $viewMode }) =>
    $viewMode === "compact" ? "6px" : "8px"};
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: border-color 0.2s ease;
  will-change: border-color;
  ${({ $viewMode }) => $viewMode === "compact" && "align-items: center;"}

  &:hover {
    border-color: rgba(0, 0, 0, 0.25);
  }

  > div:nth-child(1) {
    grid-area: vote;
    width: ${({ $viewMode }) => ($viewMode === "compact" ? "50px" : "80px")};
    min-width: ${({ $viewMode }) =>
      $viewMode === "compact" ? "50px" : "80px"};
  }

  & > *:nth-child(2) {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    margin: ${({ $viewMode }) =>
      $viewMode === "compact" ? "0 0 8px" : "0 0 16px"};
    padding: ${({ $viewMode }) =>
      $viewMode === "compact" ? "10px 16px" : "24px"};
    display: grid;
    grid-template-columns: ${({ $viewMode }) =>
      $viewMode === "compact" ? "auto 1fr auto" : "1fr 10fr 2fr"};
    grid-template-areas: "vote text options";
    gap: ${({ $viewMode }) => ($viewMode === "compact" ? "8px" : "20px")};
  }
`;

export const Main = styled.div`
  grid-area: text;
  height: 100%;
  padding: 0;
  ${({ $viewMode }) =>
    $viewMode === "compact" &&
    "display: flex; align-items: center; overflow: hidden;"}

  > h4 {
    margin: ${({ $viewMode }) => ($viewMode === "compact" ? "0" : "0 0 12px")};
    font-size: ${({ $viewMode }) =>
      $viewMode === "compact" ? "14px" : "18px"};
    line-height: ${({ $viewMode }) =>
      $viewMode === "compact" ? "1.2" : "1.4"};
    font-weight: ${({ $viewMode }) =>
      $viewMode === "compact" ? "500" : "600"};
    color: #1a1a1a;
    ${({ inModal }) => !inModal && "cursor: pointer;"}
    ${({ inModal }) => !inModal && "&:hover { color: var(--brand); }"}
    ${({ $viewMode }) =>
      $viewMode === "compact" &&
      `
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    `}
  }

  > p {
    margin: ${({ $viewMode }) => ($viewMode === "compact" ? "0" : "0 0 12px")};
    font-size: ${({ $viewMode }) =>
      $viewMode === "compact" ? "13px" : "14px"};
    line-height: 1.5;
    color: #666;
    white-space: pre-wrap;
    ${({ $viewMode }) => $viewMode === "compact" && "display: none;"}
  }
`;

export const ModalTop = styled.section`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 20px;
  grid-template-areas:
    "vote options"
    "text text";

  > div:nth-child(1) {
    grid-area: vote;
    width: 100px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    margin: 0 0 30px;
    display: grid;
    grid-template-areas:
      "text options"
      "vote options";
    grid-template-columns: 1fr 11fr 2fr;
    grid-template-rows: 1fr;
    grid-template-areas: "vote text options";
  }
`;

export const ModalButtons = styled.section`
  position: absolute;
  top: 26px;
  right: 80px;

  > button {
    margin: 10px 0 0;
  }
`;
